import { axiosInstance } from "./Api";



const buyServices = {

    getBuyOrders: async (memberid: number): Promise<any> => {
     
        const response = await axiosInstance.get(`EcomHome/GetCartProducts?memberid=${memberid}`)
        const res = JSON.parse(response.data)
        return res
    },

    postReview: async (payload: any): Promise<any> => {
        
        const response = await axiosInstance.post(`EcomHome/ReviewSave`, payload)
        return response
    },

    getReview : async(itemid:number): Promise<any> =>{
        
        const response = await axiosInstance.get(`EcomHome/GetReview?itemid=${itemid}`)
        return response
    },

    deleteCart: async(productid:number,memberid:number) : Promise<any> =>{
        const response = await axiosInstance.delete(`EcomHome/Deletecart?productid=${productid}&memberId=${memberid}`)
        return response
    }
}




export default buyServices 